// UploadSettingsService.ts

import type { ISoftwareSettingsRepository } from "@domain/repositories";
import { SettingsTypeEnumSchema, SoftwareEnumSchema, SoftwareSettingsMetadata } from "@domain/schemas/BI";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";

@injectable()
class UploadSettingsService {
  @inject(TYPES.ISoftwareSettingsRepository)
  private _settingsRepository!: ISoftwareSettingsRepository;

  async uploadSettingsAsync(
    file: File,
    softwareVersion: string,
    onProgress: (progress: number) => void,
    settingsType: SettingsTypeEnumSchema,
    projectId: string,
    software?: SoftwareEnumSchema,
    rootPath?: string,
    folder?: string,
  ): Promise<SoftwareSettingsMetadata> {
    return this._settingsRepository.createAsync(file, softwareVersion, settingsType, onProgress, projectId, software, rootPath, folder);
  }

  async checkSettingsFileExistsAsync(projectId: string, fileName: string, rootPath?: string, folder?: string): Promise<number | null> {
    return this._settingsRepository.checkFileExistsAsync(projectId, fileName, rootPath, folder);
  }
}

export { UploadSettingsService };
